const hasValue = (value) => value || value === 0

export default hasValue
